import React, { useState, useEffect } from "react";
// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
// Link
import { Link, useLocation } from "react-router-dom";
// Estilo moderno personalizado para Sidebar
import '../../../css/sidebar-modern.css';

const catalogosPaths = ["directores", "dealers", 'genres', 'blocks', 'awards', 'ponentes-evento-live', 'tags', 'nav-menu'];
const metricsPaths = ["royalties", "downloads", "overview", "engagement", "metrics", "errors", "views", "geo", "consumption", "user-report"];

const SideBar = ({ onClick }) => {
    const location = useLocation();
    let path = location.pathname.split("/");
    path = path[path.length - 1];

    const [activeAccordion, setActiveAccordion] = useState("");

    const handleAccordionToggle = (name) => {
        setActiveAccordion(prev => prev === name ? "" : name);
    };

    const closeSidebarOnMobile = () => {
        if (window.innerWidth <= 768) {
            const wrapper = document.getElementById("main-wrapper");
            if (wrapper) wrapper.classList.remove("menu-toggle");
        }
    };

    const handleNavItemClick = () => {
        if (onClick) onClick();
        closeSidebarOnMobile();
    };

    useEffect(() => {
        if (catalogosPaths.includes(path)) setActiveAccordion("catalogos");
        if (metricsPaths.includes(path)) setActiveAccordion("metrics");
    }, [path]);

    return (
        <div className="deznav sidebar-modern">
            <PerfectScrollbar className="deznav-scroll">
                <ul className="metismenu" id="menu">
                    {/* HOME BANNERS */}
                    <li className={`${path === "banners" ? "mm-active" : ""}`}>
                        <Link to="/home/banners" className="ai-icon" onClick={() => { handleAccordionToggle(""); handleNavItemClick(); }}>
                            <i className="flaticon-381-home"></i>
                            <span className="nav-text">Home Banners</span>
                        </Link>
                    </li>

                    {/* BLOQUES DE CONTENIDO */}
                    <li className={`${path === "bloques" ? "mm-active" : ""}`}>
                        <Link to="/home/bloques" className="ai-icon" onClick={() => { handleAccordionToggle(""); handleNavItemClick(); }}>
                            <i className="flaticon-381-layer"></i>
                            <span className="nav-text">Bloques de contenido</span>
                        </Link>
                    </li>

                    {/* VIDEOS */}
                    <li className={`${path === "movies" ? "mm-active" : ""}`}>
                        <Link to="/movies" className="ai-icon" onClick={() => { handleAccordionToggle(""); handleNavItemClick(); }}>
                            <i className="flaticon-381-video-player-1"></i>
                            <span className="nav-text">Videos</span>
                        </Link>
                    </li>

                    {/* EVENTOS */}
                    <li className={`${path === "eventos-live" ? "mm-active" : ""}`}>
                        <Link to="/eventos-live" className="ai-icon" onClick={() => { handleAccordionToggle(""); handleNavItemClick(); }}>
                            <i className="flaticon-381-video-camera"></i>
                            <span className="nav-text">Eventos</span>
                        </Link>
                    </li>

                    {/* ACORDEON CATÁLOGOS */}
                    <li className={`${activeAccordion === "catalogos" ? "mm-active" : ""}`}>
                        <Link 
                            className="has-arrow ai-icon" 
                            to="#" 
                            onClick={(e) => { e.preventDefault(); handleAccordionToggle("catalogos"); }}
                            aria-expanded={activeAccordion === "catalogos"}
                        >
                            <i className="flaticon-381-album-2"></i>
                            <span className="nav-text">Catálogos</span>
                        </Link>
                        <ul className={`mm-collapse ${activeAccordion === "catalogos" ? "mm-show" : ""}`}>
                            <li><Link className={`${path === "directores" ? "mm-active" : ""}`} to="/catalogos/directores" onClick={handleNavItemClick}>Ponentes</Link></li>
                            <li><Link className={`${path === "ponentes-evento-live" ? "mm-active" : ""}`} to="/catalogos/ponentes-evento-live" onClick={handleNavItemClick}>Conferencistas</Link></li>
                            <li><Link className={`${path === "tags" ? "mm-active" : ""}`} to="/catalogos/tags" onClick={handleNavItemClick}>Etiquetas</Link></li>
                            <li><Link className={`${path === "genres" ? "mm-active" : ""}`} to="/catalogos/genres" onClick={handleNavItemClick}>Categorías</Link></li>
                            <li><Link className={`${path === "blocks" ? "mm-active" : ""}`} to="/catalogos/blocks" onClick={handleNavItemClick}>Bloques de contenido</Link></li>
                            <li><Link className={`${path === "nav-menu" ? "mm-active" : ""}`} to="/catalogos/nav-menu" onClick={handleNavItemClick}>Menú de Navegación</Link></li>
                        </ul>
                    </li>

                    {/* ACORDEON ANALÍTICA */}
                    <li className={`${activeAccordion === "metrics" ? "mm-active" : ""}`}>
                        <Link 
                            className="has-arrow ai-icon" 
                            to="#" 
                            onClick={(e) => { e.preventDefault(); handleAccordionToggle("metrics"); }}
                            aria-expanded={activeAccordion === "metrics"}
                        >
                            <i className="fa fa-area-chart"></i>
                            <span className="nav-text">Analítica</span>
                        </Link>
                        <ul className={`mm-collapse ${activeAccordion === "metrics" ? "mm-show" : ""}`}>
                            <li><Link className={`${path === "overview" ? "mm-active" : ""}`} to="/analytics/overview" onClick={handleNavItemClick}>Resumen</Link></li>
                            <li><Link className={`${path === "engagement" ? "mm-active" : ""}`} to="/analytics/engagement" onClick={handleNavItemClick}>Interacción</Link></li>
                            <li><Link className={`${path === "metrics" ? "mm-active" : ""}`} to="/analytics/metrics" onClick={handleNavItemClick}>Métricas</Link></li>
                            <li><Link className={`${path === "geo" ? "mm-active" : ""}`} to="/analytics/geo" onClick={handleNavItemClick}>Geografía</Link></li>
                            <li><Link className={`${path === "errors" ? "mm-active" : ""}`} to="/analytics/errors" onClick={handleNavItemClick}>Errores</Link></li>
                            <li><Link className={`${path === "views" ? "mm-active" : ""}`} to="/analytics/views" onClick={handleNavItemClick}>Vistas</Link></li>
                            <li><Link className={`${path === "user-report" ? "mm-active" : ""}`} to="/analytics/user-report" onClick={handleNavItemClick}>Usuarios</Link></li>
                        </ul>
                    </li>
                </ul>
            </PerfectScrollbar>
        </div>
    );
};

export default SideBar;
